import React, { Component, useEffect, useState, useMemo } from "react";
import './CaseItem.scss'
import { connect } from 'react-redux';
import playPng from '../../../../../images/case/play.png'
import ixuanzhilogoPng from '../../../../../images/mine/ixuanzhilogo.png'
import { CloseCircleOutlined } from "@ant-design/icons";

const CaseItem = ({ dispatch, router, item, caseTypes }) => {
  let {
    coverPath,
    dealDate,
    caseTypeId,
    province,
    city,
    district,
    videoPath,
    caseBrokers = [],
  } = item

  const [show, setShow] = useState(false)

  const goVideo = () => {
    // window.location.href = 'https://weixin.qq.com/sph/AA6kyKhJt'
    setShow(true)
  }

  return (
    <>
      <div className="CaseItem" onClick={goVideo}>
        <img src={coverPath} />
        <div className="CaseItemInfo">
          <div className="CaseItemInfoTxt">
            <p>成交时间</p>
            <p>{dealDate}</p>
          </div>
          <div className="CaseItemInfoTxt">
            <p>成交租户类型</p>
            <p>{caseTypes.find((e) => e.id === caseTypeId).typeName}</p>
          </div>
          <div className="CaseItemInfoTxt">
            <p>成交租户位置</p>
            <p>{`${city}${district ? `-${district}` : ''}`}</p>
          </div>
          {caseBrokers &&
            caseBrokers.length > 0 &&
            caseBrokers.map((broker, index) => {
              let photo = broker.photo
                ? broker.photo
                : ixuanzhilogoPng
              return (
                <div
                  className='CaseItemInfoUser'
                  key={index}
                >
                  <img src={photo} />
                  <p >
                    {broker.brokerName} {broker.enName ? broker.enName : ''}
                  </p>
                </div>
              )
            })}

          <div className="CaseItemInfoBtn">
            <img src={playPng} />
            <p>播放完整视频</p>
          </div>
        </div>


      </div>
      {
        show && <div className="videoWrap" >
          <CloseCircleOutlined className="videoClose" onClick={() => { setShow(false) }} />
          <video controls autoPlay>
            <source src={videoPath} type="video/mp4" />
          </video>
        </div>
      }
    </>

  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(CaseItem);
